import React from 'react';
import { Box } from '@chakra-ui/react';
import { motion } from 'framer-motion';

const MotionBox = motion(Box);

const AnimatedCard = ({ children, delay = 0, ...props }) => {
  return (
    <MotionBox
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{
        duration: 0.5,
        delay: delay * 0.1,
        ease: [0.4, 0, 0.2, 1]
      }}
      whileHover={{
        y: -4,
        transition: { duration: 0.2 }
      }}
      {...props}
    >
      {children}
    </MotionBox>
  );
};

export default AnimatedCard;
